@if (data && data.state !== OPERATION_STATUS.INIT && data.state !== OPERATION_STATUS.NOT_STARTED) {
    <div class="grid grid-i3">
        @if (data.first_surnames && data.second_surnames) {
            <tec-info-group [label]="'PROCESSES.DETAIL.SURNAMES_1' | translate">
                <span>{{ data.first_surnames || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
            </tec-info-group>
            <tec-info-group [label]="'PROCESSES.DETAIL.SURNAMES_2' | translate">
                <span>{{ data.second_surnames || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
            </tec-info-group>
        } @else {
            <tec-info-group [label]="'PROCESSES.DETAIL.AEAT_MODAL.SURNAMES' | translate">
                <span>{{ data.surnames || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
            </tec-info-group>
        }
        <tec-info-group [label]="'PROCESSES.DETAIL.NAME' | translate">
            <span>{{ data.names || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-info-group>
        <tec-info-group [label]="'PROCESSES.DETAIL.NUM_DOCUMENT' | translate">
            <span>{{ data.identifier || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-info-group>
        @if (data.document_type === 'PASSPORT') {
            <tec-info-group [label]="'PROCESSES.DETAIL.PERSONAL_ID' | translate">
                <span>{{ data.personal_id || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
            </tec-info-group>
        }
        <tec-info-group [label]="'PROCESSES.DETAIL.TYPE_DOCUMENT' | translate">
            <span>{{
                masterService.hasTranslation('MASTER.DOCUMENT_TYPE.' + data.document_type)
                    ? ('MASTER.DOCUMENT_TYPE.' + data.document_type | translate)
                    : (data.document_type || ('GENERAL.NOT_AVAILABLE' | translate))
            }}</span>
        </tec-info-group>
        <tec-info-group [label]="'PROCESSES.DETAIL.EXPIRY_DATE' | translate">
            <tec-icon name="icon-calendar" />
            <span>{{ (data.expiration_date | expirationDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-info-group>
        <tec-info-group [label]="'PROCESSES.DETAIL.BIRTH_DATE' | translate">
            <tec-icon name="icon-calendar" />
            <span>{{ (data.birthdate | date : 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
            @if (yearsOld !== undefined && yearsOld !== null) {
                <tec-tag [status]="yearsOld >= 18 ? 'success' : 'warning'">
                    {{ 'PROCESSES.DETAIL.YEARS' | translate : { years_old: yearsOld } }}
                </tec-tag>
            }
        </tec-info-group>
        <tec-info-group [label]="'PROCESSES.DETAIL.GENDER' | translate">
            <span>{{
                masterService.hasTranslation('MASTER.GENDERS.' + data.gender)
                    ? ('MASTER.GENDERS.' + data.gender | translate)
                    : (data.gender ?? ('GENERAL.NOT_AVAILABLE' | translate))
            }}</span>
        </tec-info-group>
        <tec-info-group [label]="'PROCESSES.DETAIL.NACIONALITY' | translate">
            <span>
                {{
                    masterService.hasTranslation('MASTER.COUNTRIES.' + data.nationality)
                        ? ('MASTER.COUNTRIES.' + data.nationality | translate)
                        : (data.nationality ?? ('GENERAL.NO_INFO' | translate))
                }}
            </span>
        </tec-info-group>
    </div>

    <tec-divider />

    <span class="address-label">{{ ('PROCESSES.DETAIL.ADDRESS' | translate)?.toUpperCase() }}</span>
    <div class="grid grid-i3">
        <tec-info-group [label]="'PROCESSES.DETAIL.ADDRESS' | translate">
            <span>{{ data.address || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-info-group>
        <tec-info-group [label]="'PROCESSES.DETAIL.CITY' | translate">
            <span>{{ data.municipality || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-info-group>
        <tec-info-group [label]="'PROCESSES.DETAIL.PROVINCE' | translate">
            <span>{{ data.province || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-info-group>
    </div>
} @else {
    <tec-empty-state [title]="'GENERAL.NO_DATA' | translate" [size]="'default'" [type]="'empty'" />
}
